module.exports = __webpack_public_path__ + "static/Anbaugebiet-Saale-Unstrut-800x775-27e7db70b0633548680bd690f78d29da.jpeg";